import { useMemo } from 'react';
import { useGetProductTagsQuery } from '@headless-shell/store';

export function useCategoriesData(facetName) {
  const { data, isLoading, isError } = useGetProductTagsQuery();

  const categoriesData = useMemo(() => {
    if (!data) return [];

    const normalizeFacetName = (value) => String(value || '').trim().toLowerCase();
    const wantedFacet = normalizeFacetName(facetName);

    // console.log('[Solutions Debug] useCategoriesData raw data:', data, Array.isArray(data) ? 'Array' : typeof data);
    // console.log('[Solutions Debug] wantedFacet:', wantedFacet);

    // Document format:
    // [{ attributeGroups: [{ name: 'Solutions', attributeIds: [{ id, name }, ...] }, ...] }, ...]
    const flattened = [];

    const pushIfValid = (attributeId, name) => {
      if (!attributeId || !name) return;
      flattened.push({ attributeId, name });
    };

    const consumeAttributeGroups = (attributeGroups) => {
      // console.log('[Solutions Debug] consumeAttributeGroups called with:', attributeGroups);
      if (!Array.isArray(attributeGroups)) return;

      attributeGroups.forEach((group) => {
        const groupName = normalizeFacetName(group?.name);
        if (wantedFacet && groupName !== wantedFacet) return;

        const attrs = group?.attributeIds;
        if (!Array.isArray(attrs)) return;
        attrs.forEach((attr) => pushIfValid(attr?.id, attr?.name));
      });
    };

    if (Array.isArray(data)) {
      // console.log('[Solutions Debug] useCategoriesData detected new data format.');
      // New format: [{ attributeGroups: [...] }, ...]
      data.forEach((doc) => consumeAttributeGroups(doc?.attributeGroups));
    } else {
      // Defensive: support object response
      if (data?.attributeGroups) {
        consumeAttributeGroups(data.attributeGroups);
      }
    }

    console.log('[Solutions Debug] useCategoriesData flattened categories:', 
      flattened.map((attr) => ({ id: attr.attributeId, name: attr.name })));
    // Normalize to { id, name } format expected by getTranslatedCategories

    return flattened.map((attr) => ({ id: attr.attributeId, attributeId: attr.attributeId, name: attr.name }));

  }, [data, facetName]);

  return {
    categoriesData,
    isLoading,
    isError
  };
}